import * as React from 'react'
import { trackingContext } from './context'
import { type Track } from './types'

export function useTracking(): Track {
  return React.useContext(trackingContext)
}
